import { render, staticRenderFns } from "./BroadbandDataPlans.vue?vue&type=template&id=b8708724&scoped=true&"
import script from "./BroadbandDataPlans.vue?vue&type=script&lang=js&"
export * from "./BroadbandDataPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8708724",
  null
  
)

export default component.exports